import AccordionController from './components/AccordionController';
import WaypointContoller from './components/WaypointController';
import TooltipController from './components/TooltipController';
import IframesController from './components/IframesController';
import NavigationController from './components/NavigationController';
import LinkController from './components/LinkController';
import YoutubeController from './components/YoutubeController';
import OverlayController from './components/OverlayController';
import ImageGradientController from './components/ImageGradientController';
import SocialController from './components/SocialController';
import FooterController from './components/FooterController';
import EditorInfoController from './components/EditorInfoController';

require('./components/Extensions');
require('bootstrap\\js\\collapse.js');
require('bootstrap\\js\\modal.js');
require('bootstrap\\js\\tab.js');
require('bootstrap\\js\\transition.js');
require('./components/PortalImageTeaserController');
require('./components/NewsletterSignUpController');
require('./components/BackgroundVideoController');
require('./components/BackgroundController');
require('./components/RedirectController');
require('./components/SlickSliderController');
require('./components/YoutubeAutoplay.js');
require('./components/LazyLoadingController');
require('./components/plugins/AnchorOffsets');
require('./components/ProgressBarController');
require('./components/CookiesController');
require('./components/LozadController');
require('./components/ClipboardController');
require('./components/CountdownController');
require('./components/SitemapController');
require('./components/SocialController');
require('./components/ImageCreditsController');


WaypointContoller.init();
NavigationController.init();
AccordionController.init();
TooltipController.init();
IframesController.init();
LinkController.init();
YoutubeController.init();
OverlayController.init();
ImageGradientController.init();
SocialController.init();
FooterController.init();
EditorInfoController.init();
